module.exports = __webpack_public_path__ + "b39f516e90ae0b9fb8356921f81cc634.woff2";